import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { GridContainer, GridItem } from '@xing-com/grid';
import { useMediaListener, BREAKPOINTS } from '@xing-com/util';

import type { ProductType } from '../../typings/types';

import { BenefitCardList } from './benefit-card';
import { GoToProductBtn } from './go-to-product-btn';
import { SubHeadline } from './header-subline';
import { HeroHeader } from './hero-header';
import { StyledMainGridContainer, StyledMeta } from './product-benefits.styles';

export type ProductBenefitsProps = {
  product: ProductType;
};

export const ProductBenefits: React.FC<ProductBenefitsProps> = (props) => {
  const { product } = props;
  const breakpoint = useMediaListener();
  const isHandheld = breakpoint === BREAKPOINTS.handheld;

  return (
    <StyledMainGridContainer variant="FullSize">
      <GridItem span={12}>
        <HeroHeader product={product} />
      </GridItem>
      <GridItem span={12}>
        <GridContainer variant="FullSize">
          <GridItem span={11} spanMedium={9}>
            <SubHeadline product={product} />
          </GridItem>

          {!isHandheld && (
            <GridItem span={3}>
              <GoToProductBtn product={product} />
            </GridItem>
          )}
        </GridContainer>
      </GridItem>

      <GridItem span={12}>
        <BenefitCardList product={product} />
      </GridItem>

      <GridItem span={12}>
        {product === 'projobs' ? (
          <StyledMeta fontWeight="bold" size="large" noMargin>
            <FormattedMessage id="UPSELL_LOGGED_OUT_PAGE_PRODUCTS_METATEXT_PREMIUM" />
          </StyledMeta>
        ) : null}
      </GridItem>

      {isHandheld && (
        <GridItem span={12}>
          <GoToProductBtn product={product} />
        </GridItem>
      )}
    </StyledMainGridContainer>
  );
};
